import { useRecoilValue } from "recoil";
import GoogleMaps from "../../../../components/GoogleMaps";
import { officesOptions } from "../atoms/atoms";
import PropTypes from "prop-types";

const OfficeAddressInformationView = ({ data }) => {
  const officeOptions = useRecoilValue(officesOptions);
  const nextClosedOfcValue = officeOptions?.filter(
    (x) => x.value === data?.nextClosestOffice
  )[0]?.label;

  return (
    <div className="w-full border-b border-gray-200 py-1">
      <div className="grid text-xs px-10  py-2 gap-2  xl:grid-cols-2 ">
        <div className="space-y-1 ">
          <div className="space-y-1 w-full text-xs py-1">
            <div
              className={`grid grid-cols-1 lg:grid-cols-2  w-full items-center gap-2`}
            >
              <label className=" expandedLabel fontExpand ">
                Physical Address:
              </label>

              <div className="expandedData fontExpand">
                <div>
                  {data.address} {data.addressLine2}
                </div>
                <div>
                  {data.city}, {data.state} {data.zipCode}
                </div>
                <div>{data.country}</div>
              </div>
              <div></div>
              {data.shippingAddressLatitude && data.shippingAddressLongitude ? (
                <GoogleMaps
                  center={{
                    lat: parseFloat(data.shippingAddressLatitude),
                    lng: parseFloat(data.shippingAddressLongitude),
                  }}
                  physicalAddress={
                    data.address +
                    " " +
                    data.city +
                    ", " +
                    data.state +
                    " " +
                    data.zipCode +
                    " " +
                    data.country
                  }
                />
              ) : (
                <span className="italic text-xs text-red-500">
                  Warning: Address is not yet verified.
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2  w-full items-center gap-2">
            <label className="expandedLabel fontExpand text-left">
              Next Closest Office:
            </label>
            <div className="expandedData fontExpand">
              {data?.nextClosestOffice ? nextClosedOfcValue : null}
            </div>
          </div>
        </div>
        <div className="space-y-1">
          <div className="space-y-1 w-full text-xs py-1">
            <div
              className={`grid grid-cols-1 lg:grid-cols-2  w-full items-center gap-2`}
            >
              <label className="expandedLabel fontExpand text-left">
                Billing Address:
              </label>

              <div className="expandedData fontExpand">
                <div>{data.billingAddress}</div>
                <div>
                  {data.billingCity}, {data.billingState} {data.billingZipCode}
                </div>
                <div>{data.billingCountry}</div>
              </div>
              <div></div>
              {data.billingAddress &&
                data.billingAddressLatitude &&
                data.billingAddressLongitude && (
                  <GoogleMaps
                    center={{
                      lat: parseFloat(data.billingAddressLatitude),
                      lng: parseFloat(data.billingAddressLongitude),
                    }}
                    physicalAddress={data.billingAddress}
                  />
                )}
              {data.billingAddress &&
                !data.billingAddressLatitude &&
                !data.billingAddressLongitude && (
                  <span className="italic text-xs text-red-500">
                    Warning: Address is not yet verified.
                  </span>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

OfficeAddressInformationView.propTypes = {
  data: PropTypes.shape({
    suiteNumber: PropTypes.string,
    address: PropTypes.string,
    addressLine2: PropTypes.string,
  }),
};

export default OfficeAddressInformationView;
